module.exports = __webpack_public_path__ + "static/media/tablets.4c0d42ec.svg";